export default {"src":"/_next/static/media/centi.e554aed5.svg","height":48,"width":177};